var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40628 6.11206C1.03332 6.11206 0.675634 6.26022 0.411911 6.52394C0.148187 6.78766 3.05176e-05 7.14535 3.05176e-05 7.51831C3.05176e-05 7.89127 0.148187 8.24896 0.411911 8.51268C0.675634 8.7764 1.03332 8.92456 1.40628 8.92456C8.35932 8.92456 5.77689 8.92456 13.5938 8.92456C13.9667 8.92456 14.3244 8.7764 14.5882 8.51268C14.8519 8.24896 15 7.89127 15 7.51831C15 7.14535 14.8519 6.78766 14.5882 6.52394C14.3244 6.26022 13.9667 6.11206 13.5938 6.11206C5.77689 6.11206 8.35932 6.11206 1.40628 6.11206Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.44e76e680129152206e642034261b6ac.svg";
export { ForwardRef as ReactComponent };